import { createFileRoute } from '@tanstack/react-router';

import { EmailDocumentSectionEditor } from 'src/sections/admin/email-document-sections/email-document-section-editor';

export const Route = createFileRoute('/admin-skidog/email-document-sections/$id')({
  component: EmailDocumentSectionEditorPage,
});

function EmailDocumentSectionEditorPage() {
  const { id } = Route.useParams();
  if (id === 'new') {
    return <EmailDocumentSectionEditor />;
  }
  return <EmailDocumentSectionEditor sectionId={id} />;
}
